import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([{},{}]);

const DisplayFlex240 = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-flex-240');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} className="display-flex-240" />;
}
export default DisplayFlex240;
